<template>
    <div>
        <h3 class="text-center text-lg-start" v-if="!this.error">
            Oops, its not you, its us, something went <span class="remark">wrong</span> 
            while searching for <span class="output">{{ this.data }}</span>!
            <br/>
            <br/>
            <em class="text-sm">
                TIPS: Do try searching using either 
                <span class="highlight">Company Name</span> (eg: <span class="output">Apple Inc</span>
                / <span class="output">Microsoft Corp</span>) or
                <span class="highlight">Stock Quote</span> (eg: <span class="output">AAPL</span> / <span class="output">MSFT</span>)
            </em>
        </h3>
        <h3 class="text-center text-lg-start" v-else-if="this.error && this.$store.getters.isError.status === 404">
            <h2 class="remark">404</h2>Aww snap, check your connection and try again later!
        </h3>
        <h3 class="text-center text-lg-start" v-else-if="this.error && this.$store.getters.isError.status === 503">
            <h2 class="remark">503</h2>Looks like our server needs a nap time, perhaps catch a run and come back later!
        </h3>
    </div>
</template>
<script>
export default {
    props: ['data','error'],
    computed: {
        checkIsError(){
            return this.$store.getters.isError;
        },
    },
}
</script>
<style scoped>
span.remark, h2.remark {
    color:#cb4a4a;
}

h2.remark {
    font-size: 50px;
}

span.output {
    color:#827ce0;
}

.text-sm {
    font-size: 20px;
}

span.highlight {
    color:rgb(5, 190, 5);
}

.light span.remark, .light h2.remark {
    color:#8b000d;
}

.light span.output {
    color:#4d498c;
}

.light span.highlight {
    color:rgb(5, 120, 5);
}
</style>